import Searchbar from './Searchbar';

export default Searchbar;
